module.exports = __webpack_public_path__ + "img/DlshadRawand.314043c9.jpg";